import styles from './Corpo.module.css'
import Inicio from '../Conteudo/Inicio'
import Sobre from '../Conteudo/Sobre'
import Equipe from '../Conteudo/Equipe'
import Referencial from '../Conteudo/Referencial'
import Resultado from '../Conteudo/Resultado'
import Contato from '../Conteudo/Contato'
import NaveBar from '../Layout/NaveBar'

function Corpo(){
    return(
        <div className={styles.corpo}>
            <NaveBar></NaveBar>
            
            <Inicio></Inicio>
            <Sobre></Sobre>
            <Equipe></Equipe>
            <Referencial></Referencial>
            <Resultado></Resultado>
            <Contato></Contato>
        </div>
    )
}

export default Corpo